import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SessionStorageService} from './session-storage.service';
import {BaseApiService} from './base-api.service';
import {map} from 'rxjs/operators';
import { Canal, PoliticaResponse } from '../models/canal';
import { STORAGE_KEYS } from '../components/dynamic-inputs/util/constants';

@Injectable({
  providedIn: 'root'
})
export class CanalService extends BaseApiService{
  constructor(private httpClient: HttpClient, private localStorageService: SessionStorageService) {
    super('whitelabel/canais/produto', localStorageService);
  }

  get(raioMetros: number, latitude: number, longitude: number): Promise<PoliticaResponse> {

    const {productId} = this.localStorageService.getEnvConfig();
    let url: string = `${this.baseUrl}/${productId}`;

    if(raioMetros > 0 && latitude !== 0 && longitude !== 0) {
        url = url.concat(`?raio=${raioMetros}&latitude=${latitude}&longitude=${longitude}`);
    }

    return this.httpClient
      .get<any>(url)
      .pipe(map(item => item.data as PoliticaResponse))
      .toPromise();
  }
}
